import { Reveal } from "@/components/motion";

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", light = false }) {
  const center = align === "center";
  return (
    <div className={`${center ? "mx-auto text-center max-w-2xl" : "max-w-2xl"}`}>
      {eyebrow && (
        <Reveal>
          <span className={`inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.2em] ${light ? "text-[#2FA86A]" : "text-[#2FA86A]"}`}>
            <span className="h-px w-8 bg-[#2FA86A]" />
            {eyebrow}
          </span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.12] ${light ? "text-white" : "text-[#1B1B1B]"}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p className={`mt-5 text-base leading-relaxed ${light ? "text-white/60" : "text-[#1B1B1B]/60"}`}>
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
